// src/components/SyncStatusBadge.jsx
// ─────────────────────────────────────────────────────────────────────────────
//  Tiny coloured dot in the top-right of the mobile header indicating sync
//  state at a glance. Visible only when offline or pending — disappears when
//  fully synced so it doesn't add visual noise during normal use.
//
//  States:
//    offline  — red dot, pulsing
//    pending  — amber dot, pulsing
//    synced   — renders null
//
//  PLACEMENT: right side of the mobile top-header row (flex end).
// ─────────────────────────────────────────────────────────────────────────────
import React from 'react';
import { useSyncStatus } from '@/contexts/SyncStatusContext';

export default function SyncStatusBadge() {
  const { status } = useSyncStatus();

  if (status === 'synced') return null;

  const isOffline = status === 'offline';
  const color     = isOffline ? '#ef4444' : '#f59e0b';
  const label     = isOffline ? 'Offline' : 'Syncing';

  return (
    <span
      role="status"
      aria-label={label}
      title={label}
      style={{
        display:      'inline-block',
        width:        8,
        height:       8,
        borderRadius: '50%',
        background:   color,
        flexShrink:   0,
        animation:    'pulse 2s ease-in-out infinite',
        // pulse keyframes are already defined in Sheepheard's global CSS
        // (App.css / index.css) via Tailwind's animate-pulse. If not present,
        // add to index.css:
        //   @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.4} }
      }}
    />
  );
}